// extracted by mini-css-extract-plugin
export default {"background":"styles_background__Yap9o","container":"styles_container__WO5NI"};